import React from 'react';
import { Typography } from '@latitude/typography';
import {
  StyledLinkItems,
  StyledIcon,
  StyledDigitalWalletContainer,
  Wrapper
} from './DigitalWalletsRebrand.styled';

const COMPONENT_ID = 'digital-wallets-rebrand';

const defaultItems = [
  {
    title: 'Apple Pay',
    href: '/digital-wallets/apple-pay/',
    trackId: 'digital-wallets-apple-pay',
    imageSrc: require('./svg/logo-apple-pay-branded.svg')
  },
  {
    title: 'Google Pay',
    href: '/digital-wallets/google-pay/',
    trackId: 'digital-wallets-google-pay',
    imageSrc: require('./svg/logo-g-pay-branded.svg')
  },
  {
    title: 'Samsung Pay',
    href: '/digital-wallets/samsung-pay/',
    trackId: 'digital-wallets-samsung-pay',
    imageSrc: require('./svg/logo-samsung-pay-branded.svg'),
    width: 150
  }
];

const DigitalWallets = ({
  heading = 'Ready, Set, Tap',
  subheading,
  data = defaultItems,
  noShadow,
  variant,
  trackingId
}) => {
  const componentIdentifier = trackingId
    ? `${trackingId}-${COMPONENT_ID}`
    : COMPONENT_ID;
  return (
    <Wrapper id="digital-wallets" className={componentIdentifier}>
      <StyledDigitalWalletContainer>
        <Typography.H4>{heading}</Typography.H4>
        {subheading && <Typography.SH4>{subheading}</Typography.SH4>}
        <StyledLinkItems
          variant={variant}
          noStyle
          noShadow={noShadow}
          className={`${componentIdentifier}-link-container`}
        >
          {data.map((item, i) => (
            <Typography.LinkRegular
              key={i}
              href={item.href}
              trackId={`${item.trackId}`}
              trackEventData={{
                label: item.title,
                location: heading
              }}
            >
              <img
                src={item.imageSrc.default}
                alt={item.title}
                width={item.width}
              />
              {variant === 'partners' && <StyledIcon />}
            </Typography.LinkRegular>
          ))}
        </StyledLinkItems>
      </StyledDigitalWalletContainer>
    </Wrapper>
  );
};

export default DigitalWallets;
